import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import CaseIcon from '@mui/icons-material/AssignmentOutlined';
import MoreIcon from '@mui/icons-material/MoreHoriz';
import ActivityIcon from '@mui/icons-material/NotificationsNone';
import NotificationIcon from '@mui/icons-material/NotificationImportantOutlined';

import { utils } from '../../util';

const ActivityTableRow = ({ activity, onCaseOpen, onDelete, users = [] }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCaseOpen = (caseId) => {
    onCaseOpen(caseId);
    handleClose();
  };

  const handleDelete = (activityId) => {
    onDelete(activityId);
    handleClose();
  };

  const getUserName = (uid) => {
    const user = users?.find((u) => u.uid === uid);
    return user ? ` | ${user.firstName} ${user.lastName}` : '';
  };

  const formattedId = activity?.caseId?.includes("_") ? activity?.caseId?.substring(0, activity?.caseId?.indexOf("_")) : activity.caseId;

  return (
    <tr className="activity-table-row">
      <td className="activity-icon">
        {activity.type === 'notification' ? (
          <NotificationIcon fontSize="medium" color={utils.checkTimeDiff(activity.date) < 24 ? 'primary' : 'secondary'} sx={{ mt: 1 }} />
        ) : (
          <ActivityIcon fontSize="medium" color={utils.checkTimeDiff(activity.date) < 24 ? 'primary' : 'secondary'} sx={{ mt: 1 }} />
        )}
      </td>
      <td className="activity-title">{activity.title}</td>
      <td className="activity-date">
        {`${moment(activity.date).format('MMM Do YY')} | ${moment(activity.date).format('HH:mm')}${getUserName(activity.userId)}`}
      </td>
      <Box component="td" sx={{ display: { xs: 'none', sm: 'table-cell' } }} className="activity-description">
        {activity.text}
      </Box>
      <td
        className="activity-date"
        onClick={() => handleCaseOpen(activity.caseId)}
      >
        <div className="d-flex primary pointer">
          <CaseIcon />
          <span className='m-l-md'>{formattedId}</span>
        </div>
      </td>
      <td className="activity-table-action-cell">
        <IconButton edge="start" color="secondary" aria-label="menu" onClick={handleClick}>
          <MoreIcon />
        </IconButton>
        <Menu id="simple-menu" anchorEl={anchorEl} open={open} onClose={handleClose} elevation={1}>
          <MenuItem onClick={() => handleCaseOpen(activity.caseId)}>Case</MenuItem>
          <MenuItem onClick={() => handleDelete(activity.id)}>Delete</MenuItem>
        </Menu>
      </td>
    </tr>
  );
};

ActivityTableRow.propTypes = {
  activity: PropTypes.object,
  onCaseOpen: PropTypes.func,
  onDelete: PropTypes.func,
};

export default ActivityTableRow;
